// Client mirror of functions-common/src/charts/datasets/quota.ts. Keep in sync.

import type { DatasetDefinition } from '../types.js'

export const quotaDataset: DatasetDefinition = {
  key: 'quota',
  labelKey: 'NLSChartDatasetQuota',
  fields: [
    { name: 'person', labelKey: 'NLSChartFieldPerson', kind: 'dimension', type: 'string' },
    { name: 'target', labelKey: 'NLSChartFieldTarget', kind: 'dimension', type: 'string' },
    { name: 'period', labelKey: 'NLSChartFieldPeriod', kind: 'dimension', type: 'string' },
    { name: 'targetValue', labelKey: 'NLSChartFieldTargetValue', kind: 'measure', type: 'number' },
    { name: 'actualValue', labelKey: 'NLSChartFieldActualValue', kind: 'measure', type: 'number' },
    { name: 'attainment', labelKey: 'NLSChartFieldAttainment', kind: 'measure', type: 'number' },
    { name: 'periodDate', labelKey: 'NLSChartFieldPeriodDate', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'attainment', agg: 'avg' },
  defaultTimeField: 'periodDate',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER', 'HELPER'],
  available: true,
}
